import styled from 'styled-components';
import { SecondaryButton } from '../../../global/styles';

export const StyledProButton = styled(SecondaryButton)`
	position: relative;
	&:before {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		right: 12px;
		content: 'PRO';
		padding: 5px 5px;
		background: var(--orange);
		color: var(--orange-contrast);
		border-radius: 3px;
		font-size: 9px;
		font-weight: bold;
	}
	a {
		color: inherit;
		text-decoration: none;
	}
`;
